module.exports = __webpack_public_path__ + "static/media/naturgy03.e98d274f.png";